<template>
  <page-status
    class="report-list-viewer"
    :loading="loading"
    :empty="list.length === 0"
  >
    <div class="report-list">
      <div
        class="list-card"
        v-for="(report, index) in list"
        :key="index"
        @click="onClick(report.reportNo)"
      >
        <div class="card-content">
          <div class="title">{{ report.licenseNo || '新车未上牌' }}</div>
          <div class="description">
            <span class="label">报案号：</span>
            <span class="value">{{ report.reportNo }}</span>
          </div>
          <div class="description">
            <span class="label">出险时间：</span>
            <span class="value">{{ report.accidentDateTime }}</span>
          </div>
          <div class="card-right">
            <img
              v-if="report.caseStatus === CaseStatus.CS001"
              src="@/assets/img-report-status-1.png"
            />
            <img
              v-else-if="report.caseStatus === CaseStatus.CS002"
              src="@/assets/img-report-status-7.png"
            />
            <img
              v-else-if="
                report.caseStatus === CaseStatus.CS003 ||
                report.caseStatus === CaseStatus.CS004 ||
                report.caseStatus === CaseStatus.CS005
              "
              src="@/assets/img-report-status-3.png"
            />
            <img v-else src="@/assets/img-report-status-4.png" />
          </div>
        </div>
      </div>
    </div>
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import * as constants from '@/utils/constants';
import * as services from '@/services';

export default {
  name: 'ReportList',
  components: {
    PageStatus,
  },

  data() {
    return {
      loading: true,
      CaseStatus: constants.CaseStatus,
      list: [],
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { policyNo, certType, certNo } = this.$route.query;

      services.getReportsWithPolciyNo(policyNo, certType, certNo).then(res => {
        this.list = res.data;
        this.loading = false;
      });
    },

    onClick(reportNo) {
      const { certType, certNo } = this.$route.query;
      const query = { reportNo, certType, certNo };
      this.$router.push({ name: 'report-detail', query });
    },
  },
};
</script>

<style lang="less">
.report-list-viewer {
  .report-list {
    padding: 16px;

    .list-card {
      margin-bottom: 16px;
      background-color: #ffffff;
      border-radius: 4px;
      box-shadow: 0 2px 8px -2px rgba(50, 72, 94, 0.2);

      .card-content {
        position: relative;
        padding: 16px 0 16px 16px;

        .title {
          font-size: 16px;
          font-weight: bold;
          color: #434b65;
          margin-bottom: 16px;
        }

        .description {
          font-size: 12px;

          .label {
            color: #434b65;
          }

          .value {
            color: #808897;
          }
        }

        .description + .description {
          margin-top: 8px;
        }
      }

      .card-right {
        position: absolute;
        top: 12px;
        right: 12px;

        img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>
